import { IconName } from '@fortawesome/fontawesome-svg-core';
import { distinctUntilChanged } from 'rxjs/operators';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { FormControl } from '@angular/forms';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { tap, debounceTime, identity } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'tcc-mono-list-search-header',
  templateUrl: './list-search-header.component.html',
  styleUrls: ['./list-search-header.component.scss']
})
export class ListSearchHeaderComponent implements OnInit {
  public filterCtrl = new FormControl();
  @Input() debounceTime: number = 300;
  @Input() displayFilter: boolean = true;
  @Input() displaySearch: boolean = true;
  @Input() buttonType: 'button' | 'menu' | 'none' = 'menu';
  @Input() buttonIcon: IconName = 'plus';

  @Output() searchVal = new EventEmitter<string>();
  @Output() filterClicked = new EventEmitter();
  @Output() buttonClicked = new EventEmitter();

  constructor() {
    this.filterCtrl.valueChanges
      .pipe(
        untilDestroyed(this),
        this.debounceTime ? debounceTime(this.debounceTime) : identity,
        distinctUntilChanged(),
        tap((val) => this.searchVal.emit(val))
      )
      .subscribe()
  }

  ngOnInit(): void { }

  filter() {
    this.filterClicked.emit();
  }

  buttonClick() {
    if (this.buttonType === 'button') {
      this.buttonClicked.emit();
    }
  }
}
